import { OrganizationAccessLevel } from "@overmap-ai/common"
import { Slot } from "@radix-ui/react-slot"
import { forwardRef, memo, type PropsWithChildren } from "react"

import { useUserOrganizationAccess } from "../../hooks/users"

interface OrganizationAccessRequiredProps extends PropsWithChildren {
	accessLevel: OrganizationAccessLevel
	type: "disable" | "hide"
}

export const OrganizationAccessRequired = memo(
	forwardRef<HTMLElement, OrganizationAccessRequiredProps>((props, ref) => {
		const { accessLevel, children, type, ...rest } = props

		const doesUserMeetOrganizationAccessRequirement = useUserOrganizationAccess(accessLevel)

		return type === "disable" ? (
			<Slot
				ref={ref}
				// REASON: for some reason Slot does not accept a disabled prop, but it still passes it on its child component
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				disabled={!doesUserMeetOrganizationAccessRequirement}
				aria-disabled={!doesUserMeetOrganizationAccessRequirement}
				{...rest}
			>
				{children}
			</Slot>
		) : (
			<>{doesUserMeetOrganizationAccessRequirement ? children : null}</>
		)
	}),
)
